require("./calcalist_site_commercialV2.less")
import { useEffect, useRef } from "react"
import Slider from "react-slick"
import { SiteMediaData } from "widgets/interfaces"
import { LinkTargetProperties } from "global/components/linkSettings/interfaces"
import { HyperLinkBuilder } from "widgets/commonComponents/inline/hyperLink"
import { SiteMedia } from "../../../../siteWidgets/siteMedia"

export interface CommertialItemData {
    media: SiteMediaData
    title: string
    subTitle: string
    link: string
    targetLink: LinkTargetProperties
}

interface CommercialV2Props {
    tabTitle: string
    itemList: CommertialItemData[]
    tabColor: string
    tabLink: string
    tabLinkTarget: LinkTargetProperties
    titleColor: string
    subTitleColor: string
    gallerySeconds: number
}

export const CommercialV2FrontComponenta = (props: CommercialV2Props) => {
    const { itemList, tabLink, tabLinkTarget, tabColor, tabTitle, titleColor, subTitleColor, gallerySeconds } = props
    const len = itemList.length
    const sliderRef: any = useRef(null)

    // Slides are rendered reversed so slickPrev advances logically and animates L→R.
    useEffect(() => {
        if (!sliderRef.current || len <= 0) {
            return
        }

        sliderRef.current.slickGoTo(len - 1, true)
    }, [len])

    useEffect(() => {
        if (gallerySeconds <= 0 || len <= 1) {
            return
        }

        const timer = window.setInterval(() => {
            if (sliderRef.current) {
                sliderRef.current.slickPrev()
            }
        }, gallerySeconds * 1000)

        return () => window.clearInterval(timer)
    }, [gallerySeconds, len])

    const goToLogical = (logicalIndex: number) => {
        if (sliderRef.current && len > 0) {
            sliderRef.current.slickGoTo(len - 1 - logicalIndex)
        }
    }

    const goAdvance = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPrev()
        }
    }

    const goBack = () => {
        if (sliderRef.current) {
            sliderRef.current.slickNext()
        }
    }

    const settings = {
        infinite: true,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        rtl: false,
        autoplay: false,
        initialSlide: len > 0 ? len - 1 : 0,
    }

    const slides = [...itemList].reverse().map((item, reversedIndex) => {
        const logicalIndex = len - 1 - reversedIndex

        return (
            <div className="commercialV2Slot" key={logicalIndex}>
                <div className="commercialV2Media">
                    <SiteMedia
                        width={300}
                        height={183}
                        data={item.media}
                        videoSettings={null}
                        isImageLinkable={true}
                        itemLinkUrl={item.link}
                        linkTarget={item.targetLink}
                        key={item.media && item.media.url}
                    />
                </div>
            </div>
        )
    })

    return (
        <div className="CommercialV2">
            <div className="commercialV2Header" style={{ borderTopColor: tabColor }}>
                <HyperLinkBuilder className="commercialV2Tab" href={tabLink} linkTarget={tabLinkTarget} style={{ color: tabColor }}>
                    <div className="commercialV2TabText" style={{ color: tabColor }}>{tabTitle}</div>
                </HyperLinkBuilder>

                <div className="commercialV2Nav">
                    <button type="button" className="commercialV2Arrow commercialV2ArrowPrev" onClick={goAdvance} aria-label="next" />

                    <button type="button" className="commercialV2Arrow commercialV2ArrowNext" onClick={goBack} aria-label="previous" />
                </div>
            </div>

            <div className="commercialV2Body">
                <Slider ref={sliderRef} {...settings} className="commercialV2Slider">
                    {slides}
                </Slider>

                <div className="commercialV2Grid">
                    {itemList.map((item, i) =>
                        <button
                            key={i}
                            type="button"
                            className="commercialV2Cell"
                            style={{ color: titleColor }}
                            onMouseEnter={() => goToLogical(i)}
                        >
                            <HyperLinkBuilder href={item.link} linkTarget={item.targetLink} className="commercialV2CellLink">
                                <div className="commercialV2CellTitle" style={{ color: titleColor }} dangerouslySetInnerHTML={{ __html: item.title }} />

                                <div className="commercialV2CellSubTitle" style={{ color: subTitleColor }} dangerouslySetInnerHTML={{ __html: item.subTitle }} />
                            </HyperLinkBuilder>
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}

CommercialV2FrontComponenta.siteScriptName = "CommercialV2FrontComponenta"
